import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

import { TranslateModule } from '@ngx-translate/core';

import { MgButtonModule } from '@app/src/app/button';
import { MgDirectivesModule } from '@app/src/app/directives';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { MgEmailComponent, MgEmailSlot_Hint } from './Email.component';
import { MgUniqueEmailDirective } from './MgUniqueEmail.directive';

@NgModule({
  imports: [
    // Minga dependencies
    MgDirectivesModule,
    MgSpinnerModule,
    MgButtonModule,
    MgFormFieldModule,

    // External dependencies
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule.forChild(),
  ],
  declarations: [MgEmailComponent, MgEmailSlot_Hint, MgUniqueEmailDirective],
  exports: [MgEmailComponent, MgEmailSlot_Hint, MgUniqueEmailDirective],
})
export class MgEmailModule {}
